export default {
	pageName: "AdminAuthentication",
	baseUrl: "/administration/authentication-settings/",
	defaultPage: "company",
	settingsPages: {
		company: {
			pageName: "companySettings",
		},
		methods: {
			pageName: "authenticationMethods",
		},
		saml: {
			pageName: "samlSettings",
		},
		whitelisting: {
			pageName: "ipWhitelisting",
		},
		api: {
			pageName: "apiKey",
		},
	},
};
